import { IOptionItem } from "../../../../formik/formik-autocomplete/FormikAutocomplete.types";
import { ClaimCollateralType } from "../../../api/ClientFileApi";

export const ClaimMaxLength = {
  caseNumber: 30,
  collateralDetails: 4000,
} as const;

export const ExpectedLossPercentRange = {
  min: 0,
  max: 100,
  default: 100,
} as const;

/** The option of a security's asset dropdown that creates a new asset instead of picking one. */
export const NEW_HOLDING_OPTION_ID = "new";

export interface BalanceEntryFormValues {
  id: string | undefined;
  date: Date | null;
  amount: number | null;
  entryType: string | null;
}

export interface ClaimCollateralHoldingFormValues {
  institutionName: string | null;
  accountNumber: string | null;
  street: string | null;
  houseNumber: string | null;
  zipCode: string | null;
  city: string | null;
  country: string | null;
  isValueKnown: boolean | null;
  value: number | null;
  valueDate: Date | null;
  remarks: string | null;
}

export interface ClaimCollateralFormValues {
  key: string;
  id: string | null;
  type: ClaimCollateralType | null;
  /** The id of an existing asset of the asset schedule, or {@link NEW_HOLDING_OPTION_ID}. */
  holdingSelection: string | null;
  newHolding: ClaimCollateralHoldingFormValues;
  details: string | null;
}

export interface ClaimFormOptions {
  legalBasisOptions: IOptionItem[];
  disputedStatusOptions: IOptionItem[];
  collateralStatusOptions: IOptionItem[];
  claimEntirelyDisputedOptions: IOptionItem[];
  srvRegistrationStatusOptions: IOptionItem[];
  entryTypeOptions: IOptionItem[];
  /** Whether a balance-history entry type records the amount filed in the SRV. */
  isSrvRegisteredEntryType: (entryType: string | null | undefined) => boolean;
}

export interface ClaimFormCreditorInfo {
  id?: string;
  displayName?: string;
  isClientSpecific?: boolean;
}

export interface ClaimFormEditData {
  creditor: ClaimFormCreditorInfo;
  representative: ClaimFormCreditorInfo;
  hasInactiveRepresentative?: boolean;
}

export interface ClaimFormValues {
  creditorId: string;
  representativeId: string;
  caseNumber: string;
  legalBasis: string;
  disputedStatus: string;
  collateralStatus: string;
  claimEntirelyDisputed: string;
  recognizedAmount: number | null;
  srvRegistrationStatus: string;
  srvOrderNumber: number | null;
  notes: string;
  isCompleted: boolean;
  expectedLossPercent: number | null;
  collaterals: ClaimCollateralFormValues[];
  balanceEntries: BalanceEntryFormValues[];
}
